import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LayoutComponent {
  constructor() {}
}
